import React, { useState } from "react";
import { Button, TableColumnsType, TableProps, ConfigProvider, Popover, Menu, Dropdown, Space } from "antd";
import { EllipsisOutlined, DownOutlined } from "@ant-design/icons";
import { GetVendorRequestPayload, useGetVendorRequest } from "lib/hooks/VendorRequest";
import styled from "styled-components";
import SearchBar from "ui/components/Dashboard/Filter/Searchbar";
import Icon from "@ant-design/icons";
import { ReactComponent as reset } from "images/filter/reset.svg";
import { ReactComponent as Go } from "images/admin/go.svg";
import { ReactComponent as View } from "images/admin/view.svg";
import { ReactComponent as Pending } from "images/admin/pending.svg";
import RegularRequestModal from "./RegularRequest";
import CustomRequestModal from "./CustomRequest";
import OrganiserDetailsModal from "./OrganiserDetails";
import { ReactComponent as Reset } from "images/filter/reset.svg";

const Container = styled.div``;

const Topdiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 1rem;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const Left = styled.div`
  width: 60%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Right = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`;

const ResetText = styled.span`
  @media (max-width: 768px) {
    display: none;
  }
`;

// ... (keep all your existing styled components)

const VendorRequests: React.FC = () => {
  // State for modals (keep existing)
  const [regularmodalOpen, setregularModalOpen] = useState(false);
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [custommodalOpen, setcustomModalOpen] = useState(false);
  const [organizermodalOpen, setorganizerModalOpen] = useState(false);

  // State for filters
  const [requestTypeFilter, setRequestTypeFilter] = useState<string | null>(null);
  const [requestStatusFilter, setRequestStatusFilter] = useState<string | null>("pending");
  const [selectedRequestTypeLabel, setSelectedRequestTypeLabel] = useState<string>("Request type");
  const [selectedRequestStatusLabel, setSelectedRequestStatusLabel] = useState<string>("Request status");

  // Search query state
  const [searchQuery, setSearchQuery] = useState<GetVendorRequestPayload>({
    page: 1,
    limit: 20,
    status: "pending",
  });

  const { data: requests } = useGetVendorRequest(searchQuery);

  const handleSearch = (query: string) => {
    setSearchQuery(prevQuery => ({
      // ...prevQuery,
      // search: query,
      // type: requestTypeFilter,
      // status: requestStatusFilter
    }));
  };

  // Request type filter menu
  const requestTypeMenu = (
    <Menu
      onClick={e => {
        setRequestTypeFilter(e.key === "all" ? null : e.key);
        setSelectedRequestTypeLabel(
          e.key === "all" ? "Request type" : e.key === "regular" ? "Regular requests" : "Custom requests",
        );
        setSearchQuery(prev => ({ ...prev, type: e.key === "all" ? undefined : e.key }));
      }}
    >
      <Menu.Item key="all">All requests</Menu.Item>
      <Menu.Item key="regular">Regular requests</Menu.Item>
      <Menu.Item key="custom">Custom requests</Menu.Item>
    </Menu>
  );

  // Request status filter menu
  const requestStatusMenu = (
    <Menu
      onClick={e => {
        setRequestStatusFilter(e.key === "all" ? null : e.key);
        setSelectedRequestStatusLabel(
          e.key === "all"
            ? "Request status"
            : e.key === "pending"
              ? "Pending"
              : e.key === "approved"
                ? "Approved"
                : "Declined",
        );
        setSearchQuery(prev => ({ ...prev, status: e.key === "all" ? undefined : e.key }));
      }}
    >
      <Menu.Item key="all">All statuses</Menu.Item>
      <Menu.Item key="pending">Pending</Menu.Item>
      <Menu.Item key="approved">Approved</Menu.Item>
      <Menu.Item key="declined">Declined</Menu.Item>
    </Menu>
  );

  // Reset all filters
  const handleResetFilters = () => {
    setRequestTypeFilter(null);
    setRequestStatusFilter(null);
    setSelectedRequestTypeLabel("Request type");
    setSelectedRequestStatusLabel("Request status");
    setSearchQuery({ page: 1, limit: 20 });
  };

  return (
    <Container>
      <Topdiv>
        <Left>
          <SearchBar onSearch={handleSearch} />
        </Left>
        <Right>
          <Dropdown overlay={requestTypeMenu} trigger={["click"]}>
            <Button style={{ fontSize: "13px" }}>
              <Space>
                {selectedRequestTypeLabel}
                <DownOutlined />
              </Space>
            </Button>
          </Dropdown>

          <Dropdown overlay={requestStatusMenu} trigger={["click"]}>
            <Button style={{ fontSize: "13px" }}>
              <Space>
                {selectedRequestStatusLabel}
                <DownOutlined />
              </Space>
            </Button>
          </Dropdown>

          <Button type="default" onClick={handleResetFilters} style={{ fontSize: "13px" }}>
            <Space>
              <Reset />
              <ResetText>Reset filters</ResetText>
            </Space>
          </Button>
        </Right>
      </Topdiv>

      {/* Keep your existing modals */}
      {/* <RegularRequestModal open={regularmodalOpen} onCancel={handleregularModalClose} />
      <CustomRequestModal open={custommodalOpen} onCancel={handlecustomModalClose} />
      <OrganiserDetailsModal open={organizermodalOpen} onCancel={handleorganizerModalClose} /> */}
    </Container>
  );
};

export default VendorRequests;
